import { FeaturesLayoutUI } from './FeaturesLayoutUI';
import { PriorityFeatures } from './PriorityFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
export const UncategorizedFeatures = ({
  uncategorizedFeatures,
  loading,
  isCollapsible = false,
  lowerTierMessage
}) => {
  const FeaturesListSection = /*#__PURE__*/_jsx(PriorityFeatures, {
    features: uncategorizedFeatures
  });
  return /*#__PURE__*/_jsx(FeaturesLayoutUI, {
    loading: loading,
    HeaderSection: lowerTierMessage,
    FeaturesListSection: FeaturesListSection,
    isCollapsible: isCollapsible
  });
};